module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/title_flow-5332ae426b9cde38dfa1e95896e3659a.svg";